const blockFanSidedVideoAds = [
  '270',
  '138',
  '35',
  '54',
  'floor8_en_international_web',
];

export const hasFanSidedVideo = (propertyId: string) => {
  return !blockFanSidedVideoAds.includes(propertyId);
};

export const hasFanSidedAds = (propertyId: string) => {
  return !blockFanSidedVideoAds.includes(propertyId);
};
